import { localisedValue } from "utils"

const transformPolicyDetail = (response) => {
    return {
      ...response,
      policyType : localisedValue({object: response?.RepositoryPolicyType,key:"name"}),
      projects: !!response?.projects?.length && response?.projects,
      designations: !!response?.designations?.length &&  response?.designations ,
      countries: !!response?.countries?.length && response?.countries ,
      departments: !!response?.departments?.length && response?.departments ,
      staff: !!response?.staff?.length && response?.staff,
      cities: !!response?.cities?.length && response?.cities,
      description : localisedValue({object: response, key:"description"}),
      from : response?.from,
      name: localisedValue({object:response , key:"name"})
    }
}
  export default transformPolicyDetail